import company from '../data/company.json';
import styles from './StatsBar.module.css';

export default function StatsBar() {
  return (
    <section className={styles.bar}>
      <div className={styles.inner}>
        {company.stats.map((stat, i) => (
          <div key={i} className={styles.stat}>
            <span className={styles.value}>{stat.value}</span>
            <span className={styles.label}>{stat.label}</span>
            {i < company.stats.length - 1 && <div className={styles.divider} />}
          </div>
        ))}
      </div>
    </section>
  );
}
